import { render } from "./MainHeader.vue?vue&type=template&id=052aa7b2&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import "./MainHeader.vue?vue&type=style&index=0&id=052aa7b2&scoped=true&lang=css"

import exportComponent from "/home/rocky/dialogue_game2/dialogue_game/website/enmusubi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052aa7b2"]])

export default __exports__